// const BASE_URL = 'https://bot.gruz.app/api'
// const BASE_URL = 'http://127.0.0.1:5000'
const BASE_URL = 'https://tgbot-test.gruz.app/api'

const checkServerResponse = (res) => {
    if (res.ok) {
        // console.log(res.json)
        return res.json()
    }
    return Promise.reject(res);
};


export const searchOrders = (inputs, user_id, token) => {
    console.log(inputs)
    return fetch(`${BASE_URL}/search_orders`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            'data': inputs,
            'user_id': user_id
        }),
        keepalive: true
    })
        .then((res) => checkServerResponse(res))
};



export const createApplic = (inputs, token) => {
    return fetch(`${BASE_URL}/applic/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            inputs
        }),
    })
        .then((res) => checkServerResponse(res))
};

export const getUserFilters = (user_id, token) => {
    return fetch(`${BASE_URL}/getUserFilters`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            'user_id': user_id
        })
    })
        .then((res) => checkServerResponse(res))
};

export const getUserCity = (user_id, token) => {
    return fetch(`${BASE_URL}/getUserCity`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            'user_id': user_id
        })
    })
        .then((res) => checkServerResponse(res))
};



export const getUserType = (user_id, token) => {
    return fetch(`${BASE_URL}/getUserType`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            'user_id': user_id
        })
    })
        .then((res) => checkServerResponse(res))
};

export const filterCities = (query) => {
    return fetch(`${BASE_URL}/filter_cities?query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then((res) => checkServerResponse(res));
};

// Функция проверки города
export const getCityId = async (city) => {
    const response = await fetch(`${BASE_URL}/get_city_id?query=${encodeURIComponent(city)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    const data = await response.json();
    return data.cityId; // Возвращает ID города или 0, если город не найден
};


export const savePayoutToken = (payload, token) => {
  return fetch(`${BASE_URL}/payouts/token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`,

    },
    body: JSON.stringify(payload),
  }).then((res) => checkServerResponse(res))
};